export default {}

export const AUTHORISE_API_URL = process.env.VUE_APP_ROOT_AUTHORISE_API_URL
export const READ_API_URL = process.env.VUE_APP_ROOT_READ_API_URL
export const WRITE_API_URL = process.env.VUE_APP_ROOT_WRITE_API_URL

export const CREATE_REQUEST_URL = WRITE_API_URL + 'ProfileRequest/CreateFromLink'